// A request becomes obsolete when newer data is requested or written locally.
export default function createRequestGuard() {
  let version = 0;
  return {
    invalidate() { version += 1; },
    begin() {
      const requestVersion = ++version;
      return () => requestVersion === version;
    },
  };
}
